const contactMap = () => {

    if (!geojson) return 

    mapboxgl.accessToken = 'pk.eyJ1Ijoic2VwcGEtb3RhbmRlcm5vcyIsImEiOiJjazBwZHVtYTAwaXViM29xdTRyd3FheDl5In0.0YaiVpL8bLAm58jprw4n3A'

    const map = new mapboxgl.Map({
        container: 'map',
        style: 'mapbox://styles/mapbox/streets-v11', 
        center: geojson[0].geometry.coordinates,
        zoom: 10
    })

    const markers = {
        type: 'FeatureCollection', 
        features: geojson
    }

    map.on('load', () => {
        Promise.all(
            markers.features.map(feature => new Promise((resolve, reject) => {
                map.loadImage(feature.properties.icon, (error, res) => {
                    map.addImage(feature.properties.id, res)
                    resolve()
                })
            }))
        ).then(() => map.addLayer({
            id: 'points', 
            type: 'symbol', 
            source: {
                type: 'geojson',
                data: markers
            },
            layout: {
                'icon-image': '{id}',
                'icon-allow-overlap': true
            }
        }))
    })
}

const programsMap = () => {

    mapboxgl.accessToken = 'pk.eyJ1Ijoic2VwcGEtb3RhbmRlcm5vcyIsImEiOiJjazBwZHVtYTAwaXViM29xdTRyd3FheDl5In0.0YaiVpL8bLAm58jprw4n3A'
    const markers = {
        id: 'points',
        type: 'symbol', 
        source: {
            cluster: false,
            type: 'geojson',
            data: {
                type: 'FeatureCollection',
                features: features
            }
        },
        layout: {
            'icon-image': 'pin',
            'icon-size': .9
        }
    }

    const map = new mapboxgl.Map({
        container: 'map',
        style: "mapbox://styles/mapbox/streets-v10",
        center: [3.8767337, 43.6112422],
        zoom: 12
    })

    const bounds = new mapboxgl.LngLatBounds()
    features.forEach((feature) => {
        bounds.extend(feature.geometry.coordinates)
    })
    bounds._ne.lat += 0.5
    bounds._ne.lng += 0.5
    bounds._sw.lat -= 0.5
    bounds._sw.lng -= 0.5

    map.fitBounds(bounds)

    map.on('load', function() {
        map.loadImage('../wp-content/themes/seppa/image/markers/program.png', (error, image) => {
            if (error) throw error
            map.addImage('pin', image)
            map.addLayer(markers)
        })
    })

    map.on('click', 'points', function (e) {
        const coordinates = e.features[0].geometry.coordinates.slice()
        const description = "<div class='marker__content'><h3>" + e.features[0].properties.title + "</h3><a href='" + e.features[0].properties.url + "'>Voir</a></div>"

        while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
            coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
        }

        map.flyTo({center: e.features[0].geometry.coordinates})
        
        if (description) {
            new mapboxgl.Popup()
                .setLngLat(coordinates)
                .setHTML(description)
                .addTo(map);
        }
    })
        
    map.on('mouseenter', 'markers', function () {
        map.getCanvas().style.cursor = 'pointer'
    })
    
    map.on('mouseleave', 'markers', function () {
        map.getCanvas().style.cursor = ''
    })
}

export {
    contactMap, programsMap
}